<div class="wrapper" *ngIf="form">
    <div class="row">
        <div class="col-12">
            <p>
                <b>Why to use the sauna room calculator:</b>
                <br>
                For our resellers, using the sauna room calculator might be very helpful since Helo electric sauna heaters and Kastor wood-burning heaters and the variables of them are designed for specific sauna room sizes. Each product page provides details about the appropriate room size. This information can be found under the "Product Details" dropdown as "The size of the sauna (m³)”.
            </p>
            <p>
                This tool will help you to tell your customers quickly which heater model is the best fit for their sauna room. It streamlines the decision-making process between different kW variants of the heaters, improving customer satisfaction by ensuring they select the most efficient and suitable heater for their needs. Please remember that this calculator gives the calculated estimate. Different countries may have different building methods when talking about insulation and overall structure of the sauna rooms. If you’re still unsure what heater to pick, please contact our customer service.
            </p>

            <p>
                <b>How to use the sauna room calculator:</b>
                <br>
                To use the sauna room calculator, simply input the dimensions of your sauna room in the fields (Use only integers):
            </p>
            <ol class="py-0">
                <li>Enter sauna room depth, width, and height in centimeters.</li>
                <li>If the sauna room has uninsulated surfaces like windows, input the area in square meters (m²) under "Uninsulated surface m²."</li>
                <li>If your sauna has a glass door, toggle the "Sauna room has a glass door" switch.</li>
                <li>If the sauna room has a log construction, toggle the "Log construction sauna room" switch.</li>
                <li>Once you've entered all the details, click "Calculate!" to get the calculated sauna room volume.</li>
                <li>Check the recommended sauna room size of the chosen sauna heater in the “Product details” menu</li>
            </ol>
        </div>
    </div>
    <div class="row">
        <div class="col-12 col-md-6">
            <div class="image-wrapper">
                <img src="/assets/Helo_Pro_Shop_-_Sauna_room_calculator.jpg" width="100%" alt="helo-sauna-volume-calculator">
            </div>
        </div>
        <div class="col-12 col-md-6" [formGroup]="form">
            <lib-gung-number-input formControlName="depth" gungTranslate="SAUNA_DEPTH_CM"/>
            <lib-forms-message-error [controller]="form.get('depth')"></lib-forms-message-error>
            <lib-gung-number-input formControlName="width" gungTranslate="SAUNA_WIDTH_CM" extraFormClass="mt-2"/>
            <lib-forms-message-error [controller]="form.get('width')"></lib-forms-message-error>
            <lib-gung-number-input formControlName="height" gungTranslate="SAUNA_HEIGHT_CM" extraFormClass="mt-2"/>
            <lib-forms-message-error [controller]="form.get('height')"></lib-forms-message-error>
            <lib-gung-number-input formControlName="uninsulated" gungTranslate="UNINSULATED_SURFACE" extraFormClass="mt-2"/>
            <lib-forms-message-error [controller]="form.get('uninsulated')"></lib-forms-message-error>
            <div class="form-check form-switch p-0 mt-4">
                <label class="form-check-label mr-3" for="LASIOVI" translate>LASIOVI</label>
                <input class="form-check-input rounded" type="checkbox" role="switch" id="LASIOVI" formControlName="lasiovi" style="transform: scale(1.5); float: unset; margin-left: unset">
                <lib-forms-message-error [controller]="form.get('lasiovi')"></lib-forms-message-error>
            </div>
            <div class="form-check form-switch p-0 mt-2">
                <label class="form-check-label mr-3" for="LOG_CONSTRUCTION" translate>LOG_CONSTRUCTION</label>
                <input class="form-check-input rounded" type="checkbox" role="switch" id="LOG_CONSTRUCTION" formControlName="log" style="transform: scale(1.5); float: unset; margin-left: unset">
                <lib-forms-message-error [controller]="form.get('log')"></lib-forms-message-error>
            </div>
            <button type="button" class="btn btn-primary mt-4" (click)="shoot()" translate>SHOOT</button>
            <span *ngIf="calculatedVolume" class="d-block mt-4">{{'VOLUME_OF_YOUR_SAUNA' | translate: {volume: (calculatedVolume | number)} }}</span>
        </div>
    </div>

</div>